document.body.addEventListener('click', function (event) {
    if (event.target.matches('.find-size-trigger') || event.target.parentElement.matches('.find-size-trigger')) {
        let findSizeTrigger = event.target.matches('.find-size-trigger') ? event.target : event.target.parentElement;
        if (window.find_size_product_id !== findSizeTrigger.dataset.product_id) {
            window.find_size_product_id = findSizeTrigger.dataset.product_id;
            document.querySelector(`#bustButton .MuiButton-label`).firstChild.nodeValue = 'Select Bust';
            document.querySelector(`#cupButton .MuiButton-label`).firstChild.nodeValue = 'Select Cup';

            const sizeMapEl = document.querySelector(`.size-map-data[data-product_id="${window.find_size_product_id}"]`);
            if (sizeMapEl) {
                const sizeMapping = JSON.parse(sizeMapEl.textContent);
                // console.log(sizeMapping);

                const bustPopoverList = document.querySelector('#bustPopover .MuiMenu-list');
                const cupPopoverList = document.querySelector('#cupPopover .MuiMenu-list');

                let bustList = '';
                sizeMapping.bust.forEach(function (bu) {
                    bustList =
                        bustList +
                        `
                        <li class="MuiButtonBase-root MuiListItem-root MuiMenuItem-root styles_menuItem__1LG0z MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button" role="menuitem" aria-disabled="false">
                            ${bu}<span class="MuiTouchRipple-root"></span>
                        </li>
                    `;
                });
                let cupList = '';
                sizeMapping.cup.forEach(function (cu) {
                    cupList =
                        cupList +
                        `
                        <li class="MuiButtonBase-root MuiListItem-root MuiMenuItem-root styles_menuItem__1LG0z MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button" role="menuitem" aria-disabled="false">
                            ${cu}<span class="MuiTouchRipple-root"></span>
                        </li>
                    `;
                });
                bustPopoverList.innerHTML = bustList;
                cupPopoverList.innerHTML = cupList;
            }
        }
        document.querySelector('.baleaf-modal-container').style.display = 'flex';
    }
});

document.querySelector(".baleaf-modal-backdrop").addEventListener("click", function () {
    document.querySelector(".baleaf-modal-container").style.display = "none";
});
function getCssText(popover) {
    let cssText = "opacity: 1;transform: none;transition: opacity 328ms cubic-bezier(0.4, 0, 0.2, 1), transform 218ms cubic-bezier(0.4, 0, 0.2, 1);transform-origin: 0px 133px;visibility:visible;"
    cssText = cssText + "left:" + String((window.innerWidth - popover.querySelector(".MuiPaper-root").clientWidth) / 2) + "px;";
    cssText = cssText + "top:" + String((window.innerHeight - popover.querySelector(".MuiPaper-root").clientHeight) / 2) + "px;";
    return cssText;
}
document.querySelector("#bustButton").addEventListener("click", function () {
    const bustPopover = document.querySelector("#bustPopover");
    bustPopover.style.visibility = 'visible';
    bustPopover.querySelector(".MuiPaper-root").style.cssText = getCssText(bustPopover);
});
document.querySelector("#cupButton").addEventListener("click", function () {
    const cupPopover = document.querySelector("#cupPopover");
    cupPopover.style.visibility = 'visible';
    cupPopover.querySelector(".MuiPaper-root").style.cssText = getCssText(cupPopover);
});

document.querySelector("#find-size-btn").addEventListener("click", function(event) {
    const bust = document.querySelector("#bustButton .MuiButton-label").innerText;
    const cup = document.querySelector("#cupButton .MuiButton-label").innerText;
    console.log("bust", bust);
    console.log("cup", cup);
    const sizeMapEl = document.querySelector(`.size-map-data[data-product_id="${window.find_size_product_id}"]`);
    if (sizeMapEl) {
        const sizeMapping = JSON.parse(sizeMapEl.textContent);
        console.log(sizeMapping);
      
        const size = sizeMapping.sizeMap[bust]?.[cup] || window.find_size_no_result || 'No recommended size';
        console.log('推荐尺码:', size);
        document.querySelector(".size-result").textContent = size;
    }
    
    document.querySelector(".baleaf-modal-container").style.display = "none";
    document.querySelector(".recommend-modal-container").style.display = "flex";
});

document.querySelector(".go-back").addEventListener("click", function() {
    document.querySelector(".baleaf-modal-container").style.display = "flex";
    document.querySelector(".recommend-modal-container").style.display = "none";
});

document.querySelectorAll(".continue-shopping,.recommend-modal-container .baleaf-modal-backdrop").forEach(function(dom) {
    dom.addEventListener("click", function() {
        document.querySelector(".recommend-modal-container").style.display = "none";
    });
})

function hiddenPopover(selector) {
    const popover = document.querySelector(`#${selector}`);
    if (popover) {
        popover.style.visibility = 'hidden';

        const paper = popover.querySelector('.MuiPaper-root');
        if (paper) {
            paper.style.visibility = 'hidden';
        }
    } else {
        console.warn(`Element #${selector} not found`);
    }
}
function enableBtn() {
    const bust = document.querySelector("#bustButton .MuiButton-label").textContent;
    const cup = document.querySelector("#cupButton .MuiButton-label").textContent;
    if (bust && cup && (bust !== "Select Bust") && (cup !== "Select Cup")) {
        document.querySelector("#find-size-btn").disabled = false;
    }
}
document.querySelector("#bustPopover .popoverBg").addEventListener("click", function () {
    hiddenPopover("bustPopover");
});
document.querySelector("#cupPopover .popoverBg").addEventListener("click", function () {
    hiddenPopover("cupPopover");
});
function clickList(event, selector) {
    if (event.target.tagName === 'LI') {
        console.log(event.target.textContent);
        document.querySelector(`#${selector}Button .MuiButton-label`).firstChild.nodeValue = event.target.textContent;
        const selected = event.target.parentElement.querySelector(".Mui-selected");
        if (selected) {
            selected.classList.remove("Mui-selected");
        }
        event.target.classList.add("Mui-selected");
        enableBtn();
        hiddenPopover(`${selector}Popover`);
    }
}
document.querySelector("#bustPopover .MuiMenu-list").addEventListener("click", function (event) {
    clickList(event, 'bust');
});
document.querySelector("#cupPopover .MuiMenu-list").addEventListener("click", function (event) {
    clickList(event, 'cup');
});